import React, {Fragment, PureComponent} from 'react';
import {FormattedMessage} from 'react-intl';
import {Button} from '@homeaway/react-buttons';
import {SVGIcon} from '@homeaway/react-svg';
import {TrackingContext} from '@homeaway/react-event-tracking';
import {CHEVRON_RIGHT__16} from '@homeaway/svg-defs';
import {MULTI_UNIT_BUTTON_CLICK} from '../utils/edap';
import MultiUnitListWrapper from '../MultiUnitListWrapper/MultiUnitListWrapper';
import './MultiUnitModal.less';

const MULTI_UNIT_LABEL = (
    <FormattedMessage id="multipleUnitsButtonLabel" defaultMessage="View all units" />
);

export default class MultiUnitModal extends PureComponent {
    state = {
        isOpen: false
    };
    static contextType = TrackingContext;

    onModalOpen = () => {
        this.context.trigger(MULTI_UNIT_BUTTON_CLICK, this.props.listing);
        this.setState({isOpen: true});
    };

    onModalClose = () => {
        this.setState({isOpen: false});
    };

    render() {
        const {isOpen} = this.state;
        const {
            inputParams,
            listing,
            propertyName,
            currency,
            isMetric,
            isDatelessSearch,
            clientLogger
        } = this.props;

        return (
            <div className="MultiUnitModal">
                <Button
                    label={
                        <Fragment>
                            {MULTI_UNIT_LABEL}
                            <SVGIcon inlineFlex markup={CHEVRON_RIGHT__16} />
                        </Fragment>
                    }
                    size="xs"
                    className="MultiUnit__modal-btn"
                    onClick={this.onModalOpen}
                />
                {isOpen && (
                    <Fragment>
                        <MultiUnitListWrapper
                            currency={currency}
                            inputParams={inputParams}
                            isMetric={isMetric}
                            isDatelessSearch={isDatelessSearch}
                            listing={listing}
                            propertyName={propertyName}
                            showDesktopView={false}
                            onModalClose={this.onModalClose}
                            isOpen={isOpen}
                            context={'modal'}
                            clientLogger={clientLogger}
                        />
                    </Fragment>
                )}
            </div>
        );
    }
}
